import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.find.js";
import { cloneDeep } from 'lodash';
export function concept(state) {
  return state.concept;
}
export function content(state) {
  return state.content;
}
export function nGrams(state) {
  return state.nGrams;
}
export function nGramsMeta(state) {
  return state.nGramsMeta;
}
export function nGramsSelection(state) {
  return state.nGramsSelection;
}
export function cuisSelection(state) {
  return state.cuisSelection;
}
export function queriesSelection(state) {
  return state.queriesSelection;
}

/**
 * Returns an entity details if it exists.
 *
 * @param state
 * @returns {function(*): *}
 */
export function conceptDetailsById(state) {
  return function (id) {
    return state.conceptDetails[id] || null;
  };
}
export function conceptDetails(state) {
  return state.conceptDetails;
}
export function conceptQueries(state) {
  return state.conceptQueries;
}

/**
 * Remap data so its grouped by subreddit.
 *
 * @param state
 * @returns {[]}
 */
export function conceptQueriesGroupedBySubreddit(state) {
  var groups = [];
  var conceptQueries = cloneDeep(state.conceptQueries);
  conceptQueries.forEach(function (item) {
    var group = item.reddit.reddit_group;
    delete item.reddit.reddit_group;
    var foundIndex = groups.findIndex(function (g) {
      return g.id === group.id;
    });
    if (foundIndex >= 0) {
      groups[foundIndex].items.push(item);
    } else {
      group.items = [item];
      groups.push(group);
    }
  });
  return groups;
}
export function conceptQueriesMeta(state) {
  return state.conceptQueriesMeta;
}
export function selectedConcept(state) {
  return state.selectedConcept;
}
export function expanded(state) {
  return state.expanded;
}
export function expandedConceptQueries(state) {
  return state.expandedConceptQueries;
}
export function isMeshPanelShown(state) {
  return state.showMeshPanel;
}
export function appliedQueries(state) {
  return state.appliedQueries;
}
export function linkedMeshes(state) {
  return state.linkedMeshes;
}
export function isPanelFrozen(state) {
  return !!state.frozenPanels.find(function (f) {
    return f.code === state.selectedConcept.code && f.id === state.selectedConcept.id && f.term === state.selectedConcept.term;
  });
}